import IconSvg from './assets/icons/32/hint.svg';
import { FC } from 'react';
const Icon: FC = () => <img alt="hint" src={IconSvg} width="32px" height="32px" />;

export default Icon;
